import React, { forwardRef } from "react";
import { Interrogation } from "../../assets/icons";

const Banner = forwardRef(({ type, children, hideIcon = false, ...props }, ref) => (
  <>
    <div
      ref={ref}
      className={`${body[type]} p-4 rounded-[4px]`}
      role="alert"
    >
      <div className="flex items-start justify-start gap-2">
        {!hideIcon && (
          <div className="flex">
            <Interrogation
              color={InterrogationColors[type]}
              wh="24"
              strokeW="2"
            ></Interrogation>
          </div>
        )}
        <div className={`flex min-w-0 flex-1 flex-col ${content[type]}`}>{children}</div>
      </div>
    </div>
  </>
));
const InterrogationColors = {
  info: "#374151",
  warning: "#FFA43D",
  alert: "#F87171",
  disabledInfo: "#374151",
};

const body = {
  info: `bg-[#F3F4F6]`,
  disabledInfo: "",
  warning: `bg-yellow-50`,
  alert: `bg-red-50`,
};
const content = {
  info: `text-[#374151] text-sm`,
  disabledInfo: `text-[#374151] text-sm underline underline-offset-2`,
  warning: `text-yellow-700 text-sm`,
  alert: `text-red-700 text-sm`,
};
export default Banner;
